/**
 * Copy JSON Button Component
 *
 * A button that copies raw JSON output to clipboard with visual feedback.
 */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from '@mono/ui-components';
import { Check, Copy } from 'lucide-react';
import { useCallback, useState } from 'react';
export function CopyJsonButton({ data, label = 'Copy JSON', size = 'sm' }) {
    const [copied, setCopied] = useState(false);
    const handleCopy = useCallback(async ()=>{
        try {
            const json = JSON.stringify(data, null, 2);
            await navigator.clipboard.writeText(json);
            setCopied(true);
            setTimeout(()=>setCopied(false), 2000);
        } catch (error) {
            console.error('Failed to copy to clipboard:', error);
        }
    }, [
        data
    ]);
    return /*#__PURE__*/ _jsx(Button, {
        variant: "ghost",
        size: size,
        onClick: handleCopy,
        className: "h-6 text-xs opacity-70 hover:opacity-100",
        children: copied ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Check, {
                    className: "h-3 w-3 mr-1"
                }),
                "Copied"
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Copy, {
                    className: "h-3 w-3 mr-1"
                }),
                label
            ]
        })
    });
}
